import React from 'react';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';
import { itemsPerPage } from 'src/data/params';

import heroImage from 'src/images/spartiate.png';
import userImage from 'src/images/user.png';
import championsLeagueImage from 'src/images/champions_league.png';
import silverMedalImage from 'src/images/silver_medal.png';
import bronzeMedalImage from 'src/images/bronze_medal.png';
import ringAnim from 'src/images/anim/ring.svg';
import withAuth from 'src/hoc/withAuth';

const apiSearch = '/api/commercialStatistics/membersRanking';
const linkToUser = '/dashboard/user/';

class RankingCommercial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offsetMember: 0,
      dateStart: moment().subtract(7, 'day').format('YYYY-MM-DD'),
      dateEnd: moment().format('YYYY-MM-DD'),
      members: undefined,
      columnFiltered: 'orderTakingWon',
      columns: {
        orderTakingWon: 'order_taking_won',
        proposition: 'order_taking_proposition',
        nbDeals: 'nb_deals_in_charge',
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChange2 = this.handleDateChange2.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
    this.seeMore = this.seeMore.bind(this);
    this.switchColFilter = this.switchColFilter.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateStart: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }
  handleDateChange2(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateEnd: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }

  componentDidMount() {
    let search = {
      employees: true,
      orderBy: this.state.columnFiltered,
      dateStart: this.state.dateStart,
      dateEnd: this.state.dateEnd,
      limit: itemsPerPage['ranking_commercial'],
      domain: this.props.domain,
    };

    this.refreshSearch(search, 0);
  }

  refreshSearch(search, offsetNb) {
    this.setState({ pending: true });

    let queryURL = apiSearch;
    search['offset'] = offsetNb * itemsPerPage['ranking_commercial'];
    let data = 'data=' + encodeURIComponent(JSON.stringify(search));

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['membersRanking']) {
          this.setState({
            offsetMember: offsetNb, // increment or reset the current offset
            members: offsetNb > 0 ? this.state.members.concat(data['membersRanking']) : data['membersRanking'],
            hasMoreMember: data['hasMore'],
          });
        }
        this.setState({ pending: false });
      });
  }

  seeMore() {
    let search = {
      employees: true,
      orderBy: this.state.columnFiltered,
      dateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
      dateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
      limit: itemsPerPage['ranking_commercial'],
      domain: this.props.domain,
    };
    this.refreshSearch(search, this.state.offsetMember + 1);
  }

  switchColFilter(newCol) {
    this.setState({
      columnFiltered: newCol,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    let search = {
      employees: true,
      orderBy: this.state.columnFiltered,
      dateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
      dateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
      limit: itemsPerPage['ranking_commercial'],
      domain: this.props.domain,
    };

    if (nextState.columnFiltered !== this.state.columnFiltered) {
      search.orderBy = nextState.columnFiltered;
      this.refreshSearch(search, 0);
    } else if (nextState.dateStart != this.state.dateStart) {
      search.dateStart = moment(nextState.dateStart).format('YYYY-MM-DD');
      this.refreshSearch(search, 0);
    } else if (nextState.dateEnd != this.state.dateEnd) {
      search.dateEnd = moment(nextState.dateEnd).format('YYYY-MM-DD');
      this.refreshSearch(search, 0);
    } else if (nextProps.domain !== this.props.domain) {
      search.domain = nextProps.domain;
      this.refreshSearch(search, 0);
    }

    return true;
  }

  render() {
    const { members } = this.state;

    let noMembers = members && members.length === 0 ? <span>Aucun résultat.</span> : '';

    return (
      <div id='stat-container'>
        <img className={'right-hero'} src={heroImage} />
        <div id='stat-content'>
          <div id='stat-content-header' className='alignHorizontal'>
            <h2>Championnat Scaleed</h2>
            <div id='stat-aside-header-dates' className='alignHorizontal'>
              <DatePicker
                calendarContainer={this}
                name='dateStart'
                value={this.state.dateStart}
                onChange={this.handleDateChange}
                dateFormat='YYYY-MM-DD'
              />
              <span className='icon icon-arrow-right'></span>
              <DatePicker
                calendarContainer={this}
                name='dateEnd'
                value={this.state.dateEnd}
                onChange={this.handleDateChange2}
                dateFormat='YYYY-MM-DD'
              />
            </div>
          </div>
          {members && (
            <div className={'row'}>
              <div className={'col-md-4 podium-first'}>
                <div className={'card-user'}>
                  <h5>{members[0] ? members[0].member.label : ''}</h5>
                  <img
                    className={'avatar'}
                    src={
                      members[0] && members[0].member.profile_image ? '/' + members[0].member.profile_image : userImage
                    }
                  />
                  <p className={'ranking-value'}>
                    {members[0] ? members[0][this.state.columns[this.state.columnFiltered]] : ''}€
                  </p>
                  <img id='champions-league' className={'reward'} src={championsLeagueImage} />
                </div>
              </div>
              <div className={'col-md-4 podium-second'}>
                <div className={'card-user'}>
                  <h5>{members[1] ? members[1].member.label : ''}</h5>
                  <img
                    className={'avatar'}
                    src={
                      members[1] && members[1].member.profile_image ? '/' + members[1].member.profile_image : userImage
                    }
                  />
                  <p className={'ranking-value'}>
                    {members[1] ? members[1][this.state.columns[this.state.columnFiltered]] : ''}€
                  </p>
                  <img className={'reward medal-reward'} src={silverMedalImage} />
                </div>
              </div>
              <div className={'col-md-4 podium-third'}>
                <div className={'card-user'}>
                  <h5>{members[2] ? members[2].member.label : ''}</h5>
                  <img
                    className={'avatar'}
                    src={
                      members[2] && members[2].member.profile_image ? '/' + members[2].member.profile_image : userImage
                    }
                  />
                  <p className={'ranking-value'}>
                    {members[2] ? members[2][this.state.columns[this.state.columnFiltered]] : ''}€
                  </p>
                  <img className={'reward medal-reward'} src={bronzeMedalImage} />
                </div>
              </div>
            </div>
          )}
          <div id='ranking-list'>
            <table className='table'>
              <thead>
                <tr>
                  <th>
                    <span className={'icon icon-trophy'}></span>
                  </th>
                  <th>Nom</th>
                  <th
                    className={
                      'cursor ' + (this.state.columnFiltered === 'orderTakingWon' ? 'table-cell-selected ' : '')
                    }
                    onClick={() => this.switchColFilter('orderTakingWon')}
                  >
                    Gagné
                  </th>
                  <th
                    className={'cursor ' + (this.state.columnFiltered === 'proposition' ? 'table-cell-selected ' : '')}
                    onClick={() => this.switchColFilter('proposition')}
                  >
                    Proposition
                  </th>
                  <th
                    className={'cursor ' + (this.state.columnFiltered === 'nbDeals' ? 'table-cell-selected ' : '')}
                    onClick={() => this.switchColFilter('nbDeals')}
                  >
                    Affaires
                  </th>
                </tr>
              </thead>
              <tbody>
                {members ? (
                  members.map((data, i) => (
                    <tr key={i}>
                      <td
                        className={
                          'ranking-medal-' + (i === 0 ? 'gold ' : i === 1 ? 'silver ' : i === 2 ? 'bronze ' : '')
                        }
                      >
                        {i <= 2 ? <span className={'icon icon-medal'}></span> : i + 1}
                      </td>
                      <td>
                        <Link to={linkToUser + data.member.user_id}>
                          <span>{data.member.label}</span>
                        </Link>
                      </td>
                      <td
                        className={
                          'cursor ' + (this.state.columnFiltered === 'orderTakingWon' ? 'table-cell-selected ' : '')
                        }
                        onClick={() => this.switchColFilter('orderTakingWon')}
                      >
                        <span>{data.order_taking_won}€</span>
                      </td>
                      <td
                        className={
                          'cursor ' + (this.state.columnFiltered === 'proposition' ? 'table-cell-selected ' : '')
                        }
                        onClick={() => this.switchColFilter('proposition')}
                      >
                        <span>{data.order_taking_proposition}€</span>
                      </td>
                      <td
                        className={'cursor ' + (this.state.columnFiltered === 'nbDeals' ? 'table-cell-selected ' : '')}
                        onClick={() => this.switchColFilter('nbDeals')}
                      >
                        <span>{data.nb_deals_in_charge}</span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <li className='list-group-item'>Chargement...</li>
                )}
              </tbody>
            </table>
            {this.state.hasMoreMember && (
              <div className='list-see-more'>
                {this.state.pending ? (
                  <img src={ringAnim} />
                ) : (
                  <button onClick={this.seeMore} type='button' className='btn btn-sm btn-outline-success'>
                    <span className=''>Voir plus</span>
                  </button>
                )}
              </div>
            )}
            {noMembers}
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(RankingCommercial);
